import type {XlsxRow} from "./types.ts";
import {DateTime, Duration} from "luxon";

export function FutureTable({historic}: { historic: XlsxRow[] }) {
    const todayDate = DateTime.now();
    const futureDates = historic.filter(r => {
        return (r.date >= todayDate.minus(Duration.fromObject({days: 7}))) &&
            (r.date < todayDate.plus(Duration.fromObject({days: 7})));
    });
    return (
        <div class="col col-12 col-sm-6 pt-5 clearfix" id="historica">
            <h1 class="text-center">Valores históricos</h1>
            <table
                class="table w-75 ms-auto me-auto table-hover table-bordered table-striped">
                <thead>
                <tr>
                    <th>Fecha</th>
                    <th>Valor</th>
                </tr>
                </thead>
                <tbody>
                {futureDates.map(
                    dt =>
                        <tr>
                            <td>{dt.date.toISODate()}{dt.date.toISODate() === todayDate.toISODate() ? " (hoy)" : ""}</td>
                            <td>{dt.ui}</td>
                        </tr>
                )}
                </tbody>
            </table>
        </div>
    )
}